// /toeic/calculator: shows the fields of the way the reader chose. ⛔ Native
// DOM, no React, no figures: the server computes everything.
import { showsWay } from 'utils/examCalculatorForm'

function setup() {
  const form = document.querySelector('[data-toeic-form]')
  if (!form) return

  const update = () => {
    const chosen = form.querySelector('[data-toeic-way-choice]:checked')?.value || 'report'
    form.querySelectorAll('[data-toeic-way]').forEach((group) => {
      const shown = showsWay(group.dataset.toeicWay, chosen)
      group.hidden = !shown
      // A hidden field is not sent, so a stale report cannot reach the server.
      group.querySelectorAll('input, select').forEach((field) => { field.disabled = !shown })
    })
  }

  form.addEventListener('change', update)
  update()
}

document.addEventListener('DOMContentLoaded', setup)
